import { FileMetadataTypesEnum } from '../../enums/file-metadata-types.enum';
import { FormDataFileMetadata } from '../../models/form-data-file-metadata.model';

export const createFileMetadata = (
  file: File,
  fileType: FileMetadataTypesEnum
): FormDataFileMetadata => ({
  name: file.name,
  extension: file.name.replace(/^.*\.(.*)$/, '$1'),
  type: fileType,
  sizeInBytes: file.size,
});
